const KEY = "echoflicks-tv-pairing-handoff";
function link() {
  const params = new URLSearchParams(window.location.hash.split("?")[1] || "");
  const code = params.get("code");
  const serverExpiry = Number(params.get("expires_at")) * 1000;
  // Compatibility for v0.1.1 links; remove when those TV widgets are retired.
  const expires =
    serverExpiry > 0 && Number.isSafeInteger(serverExpiry)
      ? serverExpiry
      : Date.now() + 600000;
  return { code, expires };
}
export function rememberTvPairingLink() {
  const { code, expires } = link();
  if (
    !window.location.hash.startsWith("#/tv/pair") ||
    !code ||
    !/^[A-Z0-9]{8}$/.test(code) ||
    expires <= Date.now()
  )
    return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ code, expires }));
  } catch {
    /* The URL still carries the user code. */
  }
}
export function readTvPairingCode() {
  const { code: direct, expires } = link();
  if (
    window.location.hash.startsWith("#/tv/pair") &&
    direct &&
    /^[A-Z0-9]{8}$/.test(direct) &&
    expires > Date.now()
  )
    return direct;
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (saved?.expires > Date.now() && /^[A-Z0-9]{8}$/.test(saved.code))
      return saved.code;
  } catch {
    /* Optional login handoff. */
  }
  return "";
}
export function tvPairingRedirect() {
  return readTvPairingCode() ? "/tv/pair" : undefined;
}
export function clearTvPairingCode() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* Optional storage. */
  }
}
